import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../global';
import { TemperatureReadingModelExtremes } from '../models/tempread-extremes-model';
import { TemperatureReadHeadModel } from '../models/tempread-head-model';
import { TemperatureReadingModelSimple } from '../models/tempread-simple-model';
import { TemperatureReadingModelHistory } from '../models/tempread-history-model';



@Injectable()
export class TemperatureService {
  constructor(private http: HttpClient) {}

  getLatest(sensorId: string): Observable<TemperatureReadingModelSimple> {
    return this.http.get<TemperatureReadingModelSimple>(this.temperatureUrl(sensorId));
  }

  getLastDay(sensorId: string): Observable<TemperatureReadHeadModel> {
    return this.http.get<TemperatureReadHeadModel>(this.temperatureUrl(sensorId) + '/interval/HOURS/24');
  }


  getLastDayExtremes(sensorId: string): Observable<TemperatureReadingModelExtremes> {
    return this.http.get<TemperatureReadingModelExtremes>(this.temperatureUrl(sensorId) + '/extremes/DAYS/1');
  }


  getHistoryForSensor(sensorId: string): Observable<Array<TemperatureReadingModelHistory>> {
    return this.http.get<Array<TemperatureReadingModelHistory>>(this.temperatureUrl(sensorId) + '/history/');
  }

  private temperatureUrl(sensorId: string | null | undefined): string {
    const id = !sensorId || sensorId === 'null' ? '6' : sensorId;
    return `${GlobalVariable.BASE_API_URL}/temperature/${encodeURIComponent(id)}`;
  }
}
